import {
  USER_PERMISSIONS_STORAGE_KEY,
  USER_COUNTRY_STORAGE_KEY,
  USER_LOCALE_STORAGE_KEY,
  USER_DOCUMENT_TYPES_STORAGE_KEY,
} from '~/shared/config/constants'
import { storageGet, storageRemove, storageSet } from '~/shared/lib/storage'
import {
  Country,
  DocumentTypes,
  Permissions,
  UserOptionsMe,
  UserOptionsStoreType,
  Locale,
} from './types'

export class UserOptionsStore implements UserOptionsStoreType {
  private readonly storageKeyPermissions = USER_PERMISSIONS_STORAGE_KEY
  private readonly storageKeyLocale = USER_LOCALE_STORAGE_KEY
  private readonly storageKeyCountry = USER_COUNTRY_STORAGE_KEY
  private readonly storageKeyDocumentTypes = USER_DOCUMENT_TYPES_STORAGE_KEY

  private fallbackPermissions: Permissions = null
  private fallbackLocale: Locale = null
  private fallbackCountry: Country = null
  private fallbackDocumentTypes: DocumentTypes = null

  get permissions(): Permissions {
    const storageByKey = storageGet<Permissions>(this.storageKeyPermissions)

    return this.fallbackPermissions || storageByKey
  }
  get locale(): Locale {
    const storageByKey = storageGet<Locale>(this.storageKeyLocale)

    return this.fallbackLocale || storageByKey
  }
  get country(): Country {
    const storageByKey = storageGet<Country>(this.storageKeyCountry)

    return this.fallbackCountry || storageByKey
  }
  get documentTypes(): DocumentTypes {
    const storageByKey = storageGet<DocumentTypes>(this.storageKeyDocumentTypes)

    return this.fallbackDocumentTypes || storageByKey
  }

  save(options: UserOptionsMe) {
    const { permissions, taxipark, locale, documentTypes } = options

    const country = taxipark?.country || null

    storageSet<Permissions>(this.storageKeyPermissions, permissions)
    storageSet<Locale>(this.storageKeyLocale, locale)
    storageSet<Country>(this.storageKeyCountry, country)
    storageSet<DocumentTypes>(this.storageKeyDocumentTypes, documentTypes)

    this.fallbackPermissions = permissions
    this.fallbackLocale = locale
    this.fallbackCountry = country
    this.fallbackDocumentTypes = documentTypes
  }

  clear() {
    storageRemove(this.storageKeyPermissions)
    storageRemove(this.storageKeyDocumentTypes)

    this.fallbackPermissions = null
    this.fallbackCountry = null
    this.fallbackDocumentTypes = null
  }
}
